import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet"; 
import './companies_list.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { MdAnalytics, MdCheckBox, MdCheckBoxOutlineBlank, MdDashboard, MdDone, MdHome, MdLocationCity, MdMarkChatRead, MdMenu, MdMonitor, MdOutlineAnalytics, MdOutlineSelectAll, MdOutlineTabUnselected, MdSearch, MdSelectAll, MdSettings, MdSettingsAccessibility, MdTraffic } from "react-icons/md";
import { IoMdCheckbox, IoMdCheckboxOutline } from "react-icons/io";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Companies_list() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [companyData, setCompanyData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("home");
    useEffect(() => {
        const fetchCompanies = async () => {
            setIsLoading(true);
            try {
                const q = query(
                    collection(db, "companies"),
                    // where("uid", "==", uid),
                    where("guid", "==", Cookies.get("guid"))
                );

                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    console.log("No companies found");
                    setCompanyData([]);
                    return;
                }
                const docs = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();

                        // fetch child collection "fields"
                        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                        let child = {};
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue } = fieldDoc.data();
                            child[fieldName] = fieldValue;
                        });

                        const fullData = { uid: docSnap.id, ...docData, child };

                        return fullData;
                    })
                );

                setCompanyData(docs); // update state
            } catch (err) {
                console.error("Error fetching companies:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCompanies();
    }, []);
    return (
        <div>
            <div className="companies_list">
                <div className="text-h1 bold">Hello</div>
                <div className="text-h1">Welcome back to aooz-{Cookies.get("select_company_uid")}</div>
                <div className="border rounded p-2">
                    <table >
                        <tr>
                            <td  ><div onClick={() => navigate("/create-company")} className="text-h1 bold blue cursor ">Create a Companies </div></td>
                        </tr>
                        <tr>
                            <td  ><div className="text-h2">Ads that educate and inform</div></td>
                        </tr>
                        <tr>
                            <td  ><div className="text-h3 text-off">Discover ads that teach you something valuable before promoting a product</div></td>
                        </tr>
                    </table>
                </div>
                <br />
                <div className=" rounded">
                    <table>
                        <tr>
                            <td width={30} >
                                <MdSearch className="icon" />
                            </td>
                            <input type="text" className="border-none p-2" placeholder="Search company..." />
                        </tr>
                    </table>
                </div>
                {companyData && companyData.length > 0 ? (
                    companyData.map((row) => (
                        <div
                            className={`ui-items border flex m-1 ${row.companyuid === Cookies.get("select_company_uid")
                                ? "items-back-fill"
                                : "items-back"
                                }`}
                            key={row.uid}
                        >
                            <img className="icon_logo rounded"
                                src={row.logo_url || "/assets/logo.png"}
                                alt={`${row.company || "Company"} logo`}
                                
                            />

                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="fcap text-h1 bold">
                                                {row.company || "Unnamed Company"}
                                            </div>
                                        </td>
                                    </tr>
                                        <tr>
                                        <td>
                                            <div className="fcap text-h3">ID: 
                                                {row.companyuid|| "No UID"}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <a href={`/${row.slug}`}  rel="noopener noreferrer" className="text-h3 text-off">
                                                {row.slug
                                                    ? `https://aooz.in/${row.slug}`
                                                    : "No slug available"}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {row.uid === Cookies.get("select_company_uid") ? (<div className="p-33"

                                onClick={() => {
                                    Cookies.set("select_company_uid", row.companyuid);
Toastshow("Company switched successfully!"+row.company+", "+row.companyuid);
                                    //navigate(`/dashboard?menu=editcompany`);
                                    //window.location.reload();
                                }}
                            >     <MdCheckBox className="icon green" />

                            </div>) : (
                                <div>
                                    <div className="p-33"

                                        onClick={() => {
                                          Cookies.set("select_company_uid", row.companyuid);
Toastshow("Company switched successfully!"+row.company+", "+row.companyuid);
                                          //  navigate(`/dashboard?menu=editcompany`);
                                          //  window.location.reload();
                                        }}
                                    >
                                        <MdCheckBoxOutlineBlank className="icon" />
                                    </div>
                                </div>
                            )}

                        </div>
                    ))
                ) : (
                    <div>No companies found.</div>
                )}
            </div>
        </div>
    );
}
